module.exports = __webpack_public_path__ + "img/imq.9628874f.png";